import type { ReactNode } from 'react';
import styles from './index.module.scss';

export interface HonorCardProps {
  title: ReactNode;
  issuer: string;
  badge: string;
  badgeAlt: string;
}

export default function HonorCard({ title, issuer, badge, badgeAlt }: HonorCardProps) {
  return (
    <article className={styles.card}>
      <div className={styles.badgeWrap}>
        <img src={badge} alt={badgeAlt} loading="lazy" />
      </div>
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.issuer}>{issuer}</p>
      </div>
    </article>
  );
}
